// 입력 폼 스타일
export const formStyles = {
  // 전체 레이아웃
  dashboardWrapper: {
    display: 'flex',
    gap: '10px',
    padding: '10px',
    height: '100%',
    overflow: 'hidden', // 전체 스크롤 방지
    boxSizing: 'border-box'
  },
  
  // 좌측 입력 폼 컨테이너
  formContainer: {
    flex: '0 0 400px', // 고정 너비
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    overflowY: 'auto', // 독립 스크롤
    height: '100%'
  },
  
  // 섹션 제목
  formSectionTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '12.75px',
    paddingBottom: '8px',
    borderBottom: '2px solid #3498db',
    color: '#2c3e50',
    marginTop: '0' // 첫 섹션은 마진 없음
  },
  
  // 입력 그룹
  inputGroup: {
    marginBottom: '12.75px'
  },
  
  // 라벨
  label: {
    display: 'block',
    marginBottom: '5px',
    fontSize: '14px',
    color: '#636e72',
    fontWeight: '600'
  },
  
  // 입력 필드
  input: {
    width: '100%',
    padding: '8.5px',
    fontSize: '14px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s'
  },
  
  // 체크박스 라벨
  checkboxLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    fontSize: '14px',
    marginRight: '10px',
    cursor: 'pointer'
  },
  
  // 제출 버튼
  submitButton: {
    width: '100%',
    padding: '10.2px',
    fontSize: '16px',
    fontWeight: 'bold',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginTop: '12.75px'
  },
  
  // 검색 결과 드롭다운
  searchResultsDropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: 'white',
    border: '2px solid #3498db',
    borderTop: 'none',
    borderRadius: '0 0 8px 8px',
    maxHeight: '300px',
    overflowY: 'auto',
    zIndex: 1000,
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
  },
  
  searchResultItem: {
    padding: '10.2px 12.75px',
    borderBottom: '1px solid #ecf0f1',
    cursor: 'pointer',
    transition: 'background-color 0.2s'
  }
};
